export enum Relationship {
  None,
  Spouse, //Conyuge
  Children, //Hijo/a
  Other //Otros
}
